<template>
  <div class="container">
    <div class="content-wrapper">
      <!-- 步骤条 -->
      <div class="steps-wrapper">
        <div class="steps">
          <div
              v-for="(step, index) in steps"
              :key="index"
              :class="['step-item', { 'step-item-active': currentStep === index, 'step-item-completed': currentStep > index }]"
          >
            <div class="step-item-container">
              <div class="step-item-tail"></div>
              <div class="step-item-icon">
                <span v-if="currentStep > index" class="step-icon-check">
                  <el-icon><CircleCheck/></el-icon>
                </span>
                <span v-else class="step-icon-number">{{ index + 1 }}</span>
              </div>
              <div class="step-item-content">
                <div class="step-item-title">{{ step.title }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 表单卡片 -->
      <div class="card">
        <div class="card-body">
          <!-- 第一步：选择产品（图形化界面） -->
          <div v-if="currentStep === 0" class="form-step">
            <div class="product-selection">
              <!-- 产品分类选择和产品编号 -->
              <div class="product-header">
<!--                <div class="product-category-tabs">-->
<!--                  <div-->
<!--                      v-for="category in productCategoryList"-->
<!--                      :key="category.category_id"-->
<!--                      :class="['category-tab', { 'category-tab-active': selectedCategoryId === category.category_id }]"-->
<!--                      @click="selectedCategoryId = category.category_id"-->
<!--                  >-->
<!--                    {{ category.category }}-->
<!--                  </div>-->
<!--                </div>-->
                <!-- 产品编号输入 -->
                <div class="product-number-input">
                  <el-form-item prop="device_number">
                    <el-input
                        v-model="formData.device_number"
                        placeholder="产品编号"
                        style="width: 150px"
                        @input="handleNumberChange"
                    />
                  </el-form-item>
                </div>
              </div>

              <!-- 产品类型选择 -->
              <div v-if="selectedCategoryId" class="product-type-tabs">
                <div
                    v-for="subCategory in getCurrentSubCategories().slice(0, 5)"
                    :key="subCategory.sub_category_id"
                    :class="['type-tab', { 'type-tab-active': selectedSubCategoryId === subCategory.sub_category_id }]"
                    @click="selectedSubCategoryId = subCategory.sub_category_id"
                >
                  {{ subCategory.sub_category }}
                </div>
              </div>

              <!-- 产品列表（图形化展示） -->
              <div v-if="selectedSubCategoryId" class="product-grid">
                <div
                    v-for="product in getCurrentProducts()"
                    :key="product.model_id"
                    :class="['product-card', { 'product-card-selected': formData.service_device && formData.service_device.model_id === product.model_id }]"
                    @click="selectProduct(product)"
                >
                  <div class="product-image-wrapper">
                    <img
                        v-if="product.model_url"
                        :src="product.model_url"
                        :alt="product.brand_name + '-' + product.model_name"
                        class="product-image"
                    />
                    <div v-else class="product-image-placeholder">
                      <el-icon :size="40"><Picture/></el-icon>
                    </div>
                  </div>
                  <div class="product-info">
                    <div class="product-brand">{{ product.brand_name }}</div>
                    <div class="product-model">{{ product.model_name }}</div>
                  </div>
                  <div v-if="formData.service_device && formData.service_device.model_id === product.model_id" class="product-selected-icon">
                    <el-icon><CircleCheck/></el-icon>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 第二步：填写故障信息 -->
          <el-form v-if="currentStep === 1" ref="formRef1" :model="formData" :rules="formRules1" class="order-form">
            <div class="form-step fault-step-layout">
              <!-- 左侧：产品图片（约 40% 宽度） -->
              <div class="fault-left" v-if="formData.service_device">
                <div class="selected-product-display">
                  <div class="selected-product-card">
                    <div class="selected-product-image">
                      <img
                          v-if="formData.service_device.model_url"
                          :src="formData.service_device.model_url"
                          :alt="formData.service_device.brand_name + '-' + formData.service_device.model_name"
                      />
                      <div v-else class="product-image-placeholder">
                        <el-icon :size="40"><Picture/></el-icon>
                      </div>
                    </div>
                    <div class="selected-product-info">
                      <div class="selected-product-name">
                        {{ formData.service_device.brand_name }}-{{ formData.service_device.model_name }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 右侧：填写信息（约 60% 宽度） -->
              <div class="fault-right">
                <el-form-item label="故障描述" prop="malfunction_desc">
                  <el-input
                      v-model="formData.malfunction_desc"
                      type="textarea"
                      placeholder="请详细描述设备故障"
                      :rows="4"
                  />
                </el-form-item>
                <el-form-item label="照片上传" style="margin-left:10.8px">
                  <UploadMedia v-model="formData.images" accept="image"/>
                </el-form-item>
                <el-form-item label="视频上传" style="margin-left:10.8px">
                  <UploadMedia v-model="formData.videos" accept="video"/>
                </el-form-item>
              </div>
            </div>
          </el-form>

          <!-- 第三步：联系方式 -->
          <el-form v-if="currentStep === 2" ref="formRef2" :model="formData" :rules="formRules2" class="order-form">
            <div class="form-step contact-step-layout">
              <div class="contact-form-inner">
                <el-form-item label="详细地址" prop="addressObj" label-width="110" label-position="left">
                  <el-select
                      v-model="formData.addressObj"
                      placeholder="请选择地址"
                      style="width: 300px"
                      :disabled="lock"
                      @change="handleAddressChange"
                      value-key="id"
                  >
                    <el-option
                        v-for="item in addressList"
                        :key="item.id"
                        :label="item.detail_address + item.building_number"
                        :value="item"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="姓名" prop="client_name" label-width="110" label-position="left">
                  <el-input
                      v-model="formData.client_name"
                      placeholder="请输入姓名"
                      style="width: 300px"
                  />
                </el-form-item>
                <el-form-item label="联系电话" prop="client_telephone" label-width="110" label-position="left">
                  <el-input
                      v-model="formData.client_telephone"
                      placeholder="请输入联系电话"
                      style="width: 300px"
                  />
                </el-form-item>
                <el-form-item label="预约时间" prop="appointment_time" label-width="110" label-position="left">
                  <el-date-picker
                      v-model="formData.appointment_time"
                      type="datetime"
                      placeholder="时间范围在9点-20点"
                      format="YYYY-MM-DD HH:mm:ss"
                      value-format="YYYY-MM-DD HH:mm:ss"
                      style="width: 300px"
                      :disabled-date="disabledDate"
                  />
                </el-form-item>
              </div>
            </div>
          </el-form>


          <!-- 操作按钮 -->
          <div class="form-actions">
            <el-button
                v-if="currentStep > 0"
                @click="prevStep"
            >
              上一步
            </el-button>
            <el-button
                v-if="currentStep < 2"
                @click="handleReset"
            >
              重置
            </el-button>
            <el-button
                v-if="currentStep === 0"
                type="primary"
                @click="nextStep"
                :disabled="!formData.service_device"
            >
              下一步
            </el-button>
            <el-button
                v-if="currentStep === 1"
                type="primary"
                @click="nextStep"
            >
              下一步
            </el-button>
            <el-button
                v-if="currentStep === 2"
                type="primary"
                @click="handleSubmit"
                :disabled="isSubmitting"
            >
              提交订单
            </el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
  <Preview
      v-show="viewerShow"
      @close="viewerShow = false"
      :data="previewList"
      :index="previewIndex"
      :type="previewType"
  />
</template>

<style scoped>
.container {
  display: flex;
  background: #f5f6fa;
}

.content-wrapper {
  margin: auto;
  width: 68.75rem;
  padding: 1.5rem;
}

.page-header {
  text-align: center;
  margin-bottom: 2rem;
}

.page-header h1 {
  font-size: 2rem;
  font-weight: 600;
  margin: 0;
  color: #333;
}

/* 步骤条 */
.steps-wrapper {
  margin-bottom: 2rem;
}

.steps {
  display: flex;
  justify-content: center;
  position: relative;
}

.step-item {
  flex: 1;
  position: relative;
}

.step-item-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
}

.step-item-tail {
  position: absolute;
  top: 1rem;
  left: 50%;
  width: 100%;
  height: 2px;
  background: #e8e8e8;
  z-index: 0;
}

.step-item:last-child .step-item-tail {
  display: none;
}

.step-item-completed .step-item-tail {
  background: #1890ff;
}

.step-item-icon {
  position: relative;
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  background: #fff;
  border: 2px solid #e8e8e8;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1;
  transition: all 0.3s;
}

.step-item-active .step-item-icon {
  border-color: #1890ff;
  background: #1890ff;
  color: #fff;
}

.step-item-completed .step-item-icon {
  border-color: #1890ff;
  background: #1890ff;
  color: #fff;
}

.step-icon-number {
  font-size: 0.875rem;
  font-weight: 600;
  color: #999;
}

.step-item-active .step-icon-number {
  color: #fff;
}

.step-icon-check {
  color: #fff;
}

.step-item-content {
  margin-top: 0.5rem;
}

.step-item-title {
  font-size: 0.875rem;
  color: #999;
  transition: color 0.3s;
}

.step-item-active .step-item-title {
  color: #1890ff;
  font-weight: 600;
}

.step-item-completed .step-item-title {
  color: #333;
}

/* 卡片 */
.card {
  background: #fff;
  border-radius: 16px;
  box-shadow: 0 4px 24px rgba(230, 230, 230, 0.5);
  width: 52rem;
  margin: 0 auto;
}

.card-body {
  padding: 2rem 2.5rem;
}

/* 表单 */
.order-form {
  width: 100%;
}

.form-step {
  width: 100%;
}

/* 第二步布局：左右 40% / 60% 弹性盒子 */
.fault-step-layout {
  display: flex;
  gap: 1.5rem;
}

.fault-left {
  flex: 0 0 40%;
  max-width: 40%;
}

.fault-right {
  flex: 1;
}

/* 第三步：联系方式表单居中 */
.contact-step-layout {
  display: flex;
  justify-content: center;
}

.contact-form-inner {
  width: 100%;
  max-width: 420px;
}

/* 订单摘要 */
.order-summary {
  width: 100%;
}

.summary-table {
  margin-bottom: 2rem;
}

.summary-row {
  display: flex;
  padding: 0.75rem 0;
  border-bottom: 1px solid #f0f0f0;
}

.summary-row:last-child {
  border-bottom: none;
}

.summary-label {
  width: 120px;
  font-weight: 500;
  color: #666;
  flex-shrink: 0;
}

.summary-value {
  flex: 1;
  color: #333;
}

.summary-value-full {
  flex: 1 1 100%;
}

.summary-media-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.summary-media {
  width: 80px;
  height: 80px;
  object-fit: cover;
}

.summary-media:hover {
  cursor: pointer;
}

/* 操作按钮 */
.form-actions {
  display: flex;
  justify-content: center;
  gap: 1rem;
  margin-top: 2rem;
}

.swiper-area {
  margin-left: 0;
  width: 240px;
  height: 80px;
}

/* 图形化产品选择界面 */
.product-selection {
  width: 100%;
}

.product-header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 1.5rem;
  gap: 1rem;
}

.product-category-tabs {
  display: flex;
  gap: 0.75rem;
  flex-wrap: wrap;
  flex: 1;
}

.category-tab {
  padding: 0.75rem 1.5rem;
  border-radius: 8px;
  background: #f5f5f5;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.9375rem;
  border: 2px solid transparent;
}

.category-tab:hover {
  background: #e6f7ff;
  color: #1890ff;
}

.category-tab-active {
  background: #1890ff;
  color: #fff;
  border-color: #1890ff;
}

.product-type-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.type-tab {
  padding: 0.5rem 1rem;
  border-radius: 6px;
  background: #fafafa;
  color: #666;
  cursor: pointer;
  transition: all 0.3s;
  font-size: 0.875rem;
  border: 1px solid #e8e8e8;
}

.type-tab:hover {
  background: #e6f7ff;
  color: #1890ff;
  border-color: #1890ff;
}

.type-tab-active {
  background: #e6f7ff;
  color: #1890ff;
  border-color: #1890ff;
}

.product-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.product-card {
  position: relative;
  border: 2px solid #e8e8e8;
  border-radius: 12px;
  padding: 1rem;
  cursor: pointer;
  transition: all 0.3s;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
}

.product-card:hover {
  border-color: #1890ff;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.15);
  transform: translateY(-2px);
}

.product-card-selected {
  border-color: #1890ff;
  background: #e6f7ff;
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.2);
}

.product-image-wrapper {
  width: 100%;
  height: 120px;
  margin-bottom: 0.75rem;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
  border-radius: 8px;
  overflow: hidden;
}

.product-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.product-image-placeholder {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #ccc;
  background: #f5f5f5;
}

.product-info {
  width: 100%;
}

.product-brand {
  font-size: 0.875rem;
  color: #666;
  margin-bottom: 0.25rem;
  font-weight: 500;
}

.product-model {
  font-size: 0.75rem;
  color: #999;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.product-selected-icon {
  position: absolute;
  top: 0.5rem;
  right: 0.5rem;
  width: 24px;
  height: 24px;
  background: #1890ff;
  color: #fff;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
}

.product-number-input {
  flex-shrink: 0;
  margin: 0;
  padding: 0;
}

.product-number-input :deep(.el-form-item) {
  margin-bottom: 0;
}

/* 已选择产品回显 */
.selected-product-display {
  margin-bottom: 0;
  height: 100%;
}

.selected-product-card {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  gap: 1rem;
  padding: 0.75rem;
  background: #f9fafb;
  border-radius: 10px;
  border: 1px solid #eef0f4;
  height: 100%;
}

.selected-product-image {
  width: 100%;
  max-width: 360px;
  height: 260px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.selected-product-image img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}

.selected-product-info {
  width: 100%;
  text-align: center;
}

.selected-product-title {
  font-size: 0.75rem;
  color: #999;
  margin-bottom: 0.25rem;
}

.selected-product-name {
  font-size: 1rem;
  font-weight: 600;
  color: #333;
  margin-bottom: 0.25rem;
}

.selected-product-number {
  font-size: 0.875rem;
  color: #666;
}
</style>

<script setup>
import {nextTick, onMounted, reactive, ref, watch} from 'vue'
import apiClient from "@/components/plugins/axios";
import {CircleCheck, Picture} from '@element-plus/icons-vue'
import {ElLoading, ElMessage} from 'element-plus'
import UploadMedia from "@/components/templates/UploadMedia.vue";
import Preview from "@/components/templates/Preview.vue";
import 'swiper/css'
import {useRoute, useRouter} from 'vue-router'

const router = useRouter()
const route = useRoute()
const currentStep = ref(0)
const lock = ref(false)
const addressList = ref([])
const steps = ref([
  {title: '选择产品'},
  {title: '填写故障信息'},
  {title: '联系方式'}
])
const viewerShow = ref(false)
const formRef1 = ref()
const formRef2 = ref()
const previewList = ref([])
const previewIndex = ref(0)
const previewType = ref('image')
const isSubmitting = ref(false) // 防抖标志位
const formData = reactive({
  client_type: 'C_Client', // 客户类型
  b_client_id: '',
  customer_id: '', // 客户ID
  customer_name: '',
  productCategory: '', // 一级：产品分类
  serviceCategory: '', // 二级：产品类型
  service_device: '', // 三级：产品名称
  device_number: '',
  malfunction_desc: '',
  images: [],
  videos: [],
  client_name: '',
  client_telephone: '',
  addressObj: null,
  service_location_detail: '',
  client_location_point: null,
  appointment_time: ''
})

// 验证联系电话格式（支持手机和座机号）
const validatePhone = (rule, value, callback) => {
  const phone = value.trim()
  // 手机：11位数字，1开头
  const mobilePattern = /^1[3-9]\d{9}$/
  // 座机号：区号（3-4位）- 号码（7-8位），如 010-12345678 或 021-12345678
  const landlinePattern = /^0\d{2,3}-?\d{7,8}$/

  if (mobilePattern.test(phone) || landlinePattern.test(phone)) {
    callback()
  } else {
    callback(new Error('请输入正确的联系电话'))
  }
}

// 预约时间验证：只能选择当前时间之后两小时，且时间段为9:00-20:00（包含9:00和20:00，20:00为最晚）
const validateAppointmentTime = (rule, value, callback) => {
  if (!value) {
    callback()
    return
  }

  const selectedTime = new Date(value)
  const now = new Date()

  // 计算最小可选时间（当前时间+2小时）
  const minTime = new Date(now.getTime() + 2 * 60 * 60 * 1000)

  // 检查是否在当前时间+2小时之后
  if (selectedTime.getTime() < minTime.getTime()) {
    callback(new Error('预约时间必须至少在当前时间之后2小时'))
    return
  }

  // 检查时间段：必须在9:00-20:00之间（包含9:00和20:00，且20:00为最晚）
  const hour = selectedTime.getHours()
  const minute = selectedTime.getMinutes()
  const second = selectedTime.getSeconds()

  // 小时不在 9-20 之间，直接不通过
  if (hour < 9 || hour > 20) {
    callback(new Error('预约时间必须在9:00-20:00之间'))
    return
  }

  // 20点以后只允许 20:00 整点，20:01 及之后不允许
  if (hour === 20 && (minute > 0 || second > 0)) {
    callback(new Error('最晚只能选择20:00'))
    return
  }

  callback()
}

// 第二步表单验证规则（故障信息）
const formRules1 = reactive({
  malfunction_desc: [
    {required: true, message: '请填写故障描述', trigger: 'blur'},
  ]
})

// 第二步表单验证规则
const formRules2 = reactive({
  client_name: [
    {required: true, message: '请填写姓名', trigger: 'blur'}
  ],
  client_telephone: [
    {required: true, message: '请填写联系电话', trigger: 'blur'},
    {validator: validatePhone, trigger: 'blur'}
  ],
  addressObj: [
    {required: true, message: '请填写详细地址', trigger: 'blur'}
  ],
  appointment_time: [
    {required: true, message: '请选择预约时间', trigger: 'change'},
    {validator: validateAppointmentTime, trigger: 'change'}
  ]
})

// 禁用日期：只能选择今天及之后的日期
const disabledDate = (time) => {
  const today = new Date()
  today.setHours(0, 0, 0, 0)
  const timeDate = new Date(time)
  timeDate.setHours(0, 0, 0, 0)

  // 禁用今天之前的日期
  return timeDate.getTime() < today.getTime()
}

// 一级：产品分类列表（category）
const productCategoryList = ref([])
// 二级：产品类型列表（sub_category，根据选中的 productCategory 过滤）
const categoryList = ref([])
// 三级：产品名称列表（brand + model，根据选中的 serviceCategory 过滤）
const subCategoryList = ref([])


async function getCategories() {
  const res = await apiClient.get(`/api/v1/device/category/all`)
  if (res.data.code === 200) {
    // 存储完整的三级数据结构
    productCategoryList.value = res.data.data || []
    
    // 检查路由参数，如果有 categoryId 和 subCategoryId，则选择对应的分类和子分类
    const categoryIdParam = route.query.categoryId ? Number(route.query.categoryId) : null
    const subCategoryIdParam = route.query.subCategoryId ? Number(route.query.subCategoryId) : null
    
    if (categoryIdParam && subCategoryIdParam) {
      // 根据路由参数选择分类和子分类
      selectCategoryAndSubCategory(categoryIdParam, subCategoryIdParam)
    } else {
      // 没有路由参数，自动选择第一个产品
      autoSelectFirstProduct()
    }
  }
}

// 根据 categoryId 和 subCategoryId 选择分类和子分类
function selectCategoryAndSubCategory(categoryId, subCategoryId) {
  nextTick(() => {
    const category = productCategoryList.value.find(cat => cat.category_id === categoryId)
    if (!category) {
      // 找不到分类，回退到默认选择
      autoSelectFirstProduct()
      return
    }
    
    // 选择一级分类
    selectedCategoryId.value = category.category_id
    
    nextTick(() => {
      const subCategory = category.child?.find(sub => sub.sub_category_id === subCategoryId)
      if (!subCategory) {
        // 找不到子分类，回退到默认选择
        autoSelectFirstProduct()
        return
      }
      
      // 选择二级分类
      selectedSubCategoryId.value = subCategory.sub_category_id
      
      // 自动选择第一个产品
      nextTick(() => {
        if (subCategory.child && subCategory.child.length > 0) {
          const firstProduct = subCategory.child[0]
          selectProduct(firstProduct)
        }
      })
    })
  })
}

// 自动选择第一个产品
function autoSelectFirstProduct() {
  if (productCategoryList.value.length === 0) return
  
  // 使用 nextTick 确保数据更新完成后再选择
  nextTick(() => {
    const firstCategory = productCategoryList.value[0]
    if (!firstCategory) return
    
    // 选择第一个分类
    selectedCategoryId.value = firstCategory.category_id
    
    // 等待 watch 执行完成后再选择子分类
    nextTick(() => {
      if (firstCategory.child && firstCategory.child.length > 0) {
        const firstSubCategory = firstCategory.child[0]
        selectedSubCategoryId.value = firstSubCategory.sub_category_id
        
        // 等待 watch 执行完成后再选择产品
        nextTick(() => {
          if (firstSubCategory.child && firstSubCategory.child.length > 0) {
            const firstProduct = firstSubCategory.child[0]
            selectProduct(firstProduct)
          }
        })
      }
    })
  })
}


getCategories()

// 加载地址列表
async function getAddressList() {
  try {
    const res = await apiClient.get('/api/v1/address/')
    if (res.data.code === 200) {
      addressList.value = res.data.data || []
      if (addressList.value.length > 0) {
        const value = addressList.value[0]
        formData.addressObj = value
        formData.service_location_detail = value.detail_address + value.building_number
        formData.client_location_point = value.location
        formData.client_name = value.contact_name
        formData.client_telephone = value.telephone
      }
    }
  } catch (error) {
    ElMessage.error({
      message: '地址加载失败',
      duration: 1000,
    });
  }
}

// 选择地址后更新经纬度
function handleAddressChange(value) {
  formData.service_location_detail = value.detail_address + value.building_number
  formData.client_location_point = value.location
  formData.client_name = value.contact_name
  formData.client_telephone = value.telephone
}

// 图形化产品选择相关状态
const selectedCategoryId = ref(null)
const selectedSubCategoryId = ref(null)

// 获取当前分类下的子分类列表
function getCurrentSubCategories() {
  if (!selectedCategoryId.value) return []
  const category = productCategoryList.value.find(cat => cat.category_id === selectedCategoryId.value)
  return category ? (category.child || []) : []
}

// 获取当前子分类下的产品列表
function getCurrentProducts() {
  if (!selectedSubCategoryId.value) return []
  const subCategory = getCurrentSubCategories().find(sub => sub.sub_category_id === selectedSubCategoryId.value)
  return subCategory ? (subCategory.models || []) : []
}

// 选择产品
function selectProduct(product) {
  formData.service_device = product
  // 同时设置对应的分类信息
  const category = productCategoryList.value.find(cat => cat.category_id === selectedCategoryId.value)
  if (category) {
    formData.productCategory = category
    const subCategory = category.child?.find(sub => sub.sub_category_id === selectedSubCategoryId.value)
    if (subCategory) {
      formData.serviceCategory = subCategory
    }
  }
}

// 根据当前选择的分类和子分类自动选择第一个产品
function autoSelectFirstProductByCurrentSelection() {
  if (!selectedCategoryId.value) return
  
  const category = productCategoryList.value.find(cat => cat.category_id === selectedCategoryId.value)
  if (!category || !category.child || category.child.length === 0) return
  
  // 如果还没有选择子分类，自动选择第一个子分类
  if (!selectedSubCategoryId.value) {
    selectedSubCategoryId.value = category.child[0].sub_category_id
    // 设置子分类后，会触发 watch，在那里选择产品
    return
  }
  
  // 已经有子分类，直接选择第一个产品
  const subCategory = category.child.find(sub => sub.sub_category_id === selectedSubCategoryId.value)
  if (subCategory && subCategory.child && subCategory.child.length > 0) {
    const firstProduct = subCategory.child[0]
    selectProduct(firstProduct)
  }
}

// 监听分类选择变化，自动选择第一个产品
watch(selectedCategoryId, (newVal) => {
  if (newVal) {
    selectedSubCategoryId.value = null
    formData.serviceCategory = ''
    formData.service_device = ''
    // 自动选择第一个产品（会先选择第一个子分类，然后触发子分类的 watch）
    nextTick(() => {
      autoSelectFirstProductByCurrentSelection()
    })
  }
})

// 监听子分类选择变化，自动选择第一个产品
watch(selectedSubCategoryId, (newVal) => {
  if (newVal) {
    formData.service_device = ''
    // 自动选择第一个产品
    nextTick(() => {
      autoSelectFirstProductByCurrentSelection()
    })
  }
})

// 产品编号输入防抖处理
let numberChangeTimer = null

// 锁定产品
function handleNumberChange() {
  // 清除之前的定时器
  if (numberChangeTimer) {
    clearTimeout(numberChangeTimer)
  }

  // 设置新的定时器，300ms后执行
  numberChangeTimer = setTimeout(async function () {
    if (formData.device_number === '') {
      return
    }
    const res = await apiClient.get('/api/v1/device/device/' + formData.device_number)
    if (res.data.code === 200) {
      if (res.data.data != null) {
        ElMessage({
          message: '绑定成功',
          type: 'success',
          duration: 1000
        })
        lock.value = true
        currentStep.value++
        formData.client_type = res.data.data.device_type
        formData.customer_id = res.data.data.customer_id
        formData.customer_name = res.data.data.customer_name
        formData.b_client_id = res.data.data.client_id
        formData.service_device = res.data.data.machine_model_json
        formData.device_number = res.data.data.machine_number
        formData.addressObj = {
          id: 1,
          detail_address: res.data.data.detail_address,
          building_number: ''
        }
        addressList.value = [formData.addressObj]
        formData.client_name = res.data.data.contact
        formData.client_telephone = res.data.data.contact_phone
        formData.service_location_detail = res.data.data.detail_address
        formData.client_location_point = res.data.data.location
      } else {
        ElMessage({
          message: '该设备未入库',
          type: 'info',
          duration: 1000
        });
      }
    }
    numberChangeTimer = null
  }, 300)
}

// 步骤控制
function nextStep() {
  if (currentStep.value === 0) {
    // 第一步：图形化选择产品，只需要检查是否选择了产品
    if (!formData.service_device) {
      ElMessage.warning('请先选择产品')
      return
    }
    currentStep.value++
  } else if (currentStep.value === 1) {
    // 验证第二步表单（故障信息）
    if (!formRef1.value) {
      return
    }
    formRef1.value.validate(function (valid) {
      if (valid) {
        currentStep.value++
      }
    })
  }
}

function prevStep() {
  if (currentStep.value > 0) {
    currentStep.value--
  }
}


// 重置表单
function handleReset() {
  // 重置步骤
  currentStep.value = 0
  // 重置锁定状态
  lock.value = false
  // 重置图形化选择状态
  selectedCategoryId.value = null
  selectedSubCategoryId.value = null
  // 重置表单数据
  formData.client_type = 'C_Client'
  formData.b_client_id = ''
  formData.customer_name = ''
  formData.customer_id = ''
  formData.productCategory = ''
  formData.serviceCategory = ''
  formData.service_device = ''
  formData.device_number = ''
  formData.malfunction_desc = ''
  formData.images = []
  formData.videos = []
  formData.client_name = ''
  formData.client_telephone = ''
  formData.addressObj = null
  formData.service_location_detail = ''
  formData.client_location_point = null
  formData.appointment_time = ''
  // 重置产品列表
  categoryList.value = []
  subCategoryList.value = []
  // 重置表单验证状态
  if (formRef1.value) {
    formRef1.value.clearValidate()
  }
  if (formRef2.value) {
    formRef2.value.clearValidate()
  }
  getAddressList()
  // 自动选择第一个产品
  autoSelectFirstProduct()
}

function openPreview(list, index, type) {
  viewerShow.value = true
  previewList.value = list
  previewIndex.value = index
  previewType.value = type
}

// 提交表单
async function handleSubmit() {
  // 防抖：如果正在提交，直接返回
  if (isSubmitting.value) {
    return
  }

  // 先校验第三步表单（联系方式 + 预约时间）
  if (!formRef2.value) {
    return
  }

  const valid = await new Promise(resolve => {
    formRef2.value.validate(ok => resolve(ok))
  })

  if (!valid) {
    // 校验不通过，直接返回，不提交
    return
  }

  // 显示加载状态
  const loading = ElLoading.service({
    lock: true,
    text: '正在提交订单...',
    background: 'rgba(0, 0, 0, 0.7)'
  })

  // 设置提交标志
  isSubmitting.value = true

  try {
    let data = {
      service_type: "REPAIR_ORDER",
      client_type: formData.client_type,
      customer_id: formData.customer_id,
      device_number: formData.device_number,
      client_name: formData.client_name,
      client_telephone: formData.client_telephone,
      service_device: formData.service_device,
      malfunction_desc: formData.malfunction_desc,
      malfunction_attachments: {
        videos: formData.videos.map(item => item.url),
        pictures: formData.images.map(item => item.url),
      },
      appointment_time: formData.appointment_time,
      service_model: '上门',
      client_location_point: formData.client_location_point,
      service_location_detail: formData.service_location_detail
    }
    const res = await apiClient.post('/api/v1/order/submit', data);
    if (res.data.code === 200) {
      ElMessage.success({
        message: '下单成功',
        duration: 1000
      })
      await router.push('/workOrder')
    } else {
      ElMessage.error({
        message: res.data.message,
        duration: 1000
      })
    }
  } catch (error) {
    ElMessage.error({
      message: '提交失败，请稍后重试',
      duration: 1000
    })
  } finally {
    // 关闭加载状态
    loading.close()
    // 重置提交标志
    isSubmitting.value = false
  }
}

onMounted(() => {
  getAddressList()
})
</script>